import { render, staticRenderFns } from "./ActivityWordSearchWords.vue?vue&type=template&id=10259b96&scoped=true"
import script from "./ActivityWordSearchWords.vue?vue&type=script&lang=ts"
export * from "./ActivityWordSearchWords.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWordSearchWords.vue?vue&type=style&index=0&id=10259b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10259b96",
  null
  
)

/* custom blocks */
import block0 from "./ActivityWordSearchWords.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports